export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CarouselArrow.vue?vue&type=template&id=147005cc&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/CarouselArrow.vue?vue&type=template&id=147005cc&scoped=true&
// module id = 163
// module chunks = 0